import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";

import clsx from "clsx";
import { forwardRef } from "react";
import Spinner from "../Spinner";
import { Icon } from "../Icon";
import * as MUIIcon from "react-icons/md";

interface ButtonTypes extends LoadingButtonProps {
  style?: React.CSSProperties;
  className?: string;
  icon?: keyof typeof MUIIcon;
  loading?: boolean;
}

export const Button = forwardRef(
  ({ className, icon, children, ...rest }: ButtonTypes, ref) => {
    return (
      <LoadingButton
        loadingIndicator={
          <Spinner
            className={rest.disabled ? "text-gray-40" : "text-primary-60"}
            size={18}
          />
        }
        className={clsx("", className)}
        {...rest}
      >
        {icon && <Icon icon={icon} className="cursor-pointer" />}
        {children}
      </LoadingButton>
    );
  }
);
